<template>
  <div class="bbs-show">
    <van-nav-bar
    v-if="source==1"
    :title="info.title"
    left-arrow
    :fixed="true"
    @click-left="onClickLeft"
    />
    <van-nav-bar
    v-if="source==1&&pageLength==1"
    :title="info.title"
    :fixed="true"
    @click-left="onClickLeft">
    <template #left>
      <van-icon name="wap-home-o" size="18" />
    </template>
  </van-nav-bar>
  <div class="show" :style="{'margin-top':source==1?'50px':'0'}" v-if="info">
    <van-row type="flex" justify="space-between" v-if="info.user">
      <van-col span="4">
        <img class="listhand" :src="info.user.headimg_url ? info.user.headimg_url : img.avatar">
      </van-col>
      <van-col span="16">
        <div class="membername">
          {{ info.user.user_name }}
        </div>
        <div class="sourtime">
          {{ info.time_format }}  浏览 {{ info.show_num }}
        </div>
      </van-col>
      <van-col class="bintright" span="4">
        <!-- <van-button plain round>+关注</van-button> -->
      </van-col>
    </van-row>
    <h1 v-if="info.title">{{ info.title }}</h1>
    <p>{{ info.content }}</p>
    <img class="img" v-for="(img, index) in info.image" :key="'img_' + index" v-lazy="img" />
    <div class="tag">
      <van-row type="flex" justify="space-between">
        <van-col span="18">
          <van-tag plain v-for="t in info.tags" :key="'tag_' + t.id + '_id_' + info.id">{{ t.name }}</van-tag>
        </van-col>
        <van-col span="6" class="tip">
          <span @click="toTip">举报</span>
        </van-col>
      </van-row>
    </div>
    <div class="parise">
      <router-link to="" @click.native="setPraise">
        <img :src="info.is_praise ? img.parise_have : img.show_parise" />
        点赞
      </router-link>
    </div>
  </div>
  <!-- 评论 -->
  <div class="comments">
    <h2>全部回帖</h2>
    <van-list
    v-model="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="onLoad"
    >
    <div slot="loading" class="list-loading">
      <img :src="this.img.loading" />
      <span>正在刷新</span>
    </div>
    <div class="comment">
      <div v-for="(comment, index) in comments" :key="'commment_' + comment.id">
       <!-- v-if="source==1&&index<5" -->
        <van-row gutter="15">
          <van-col span="3">
            <img class="avatar" :src="comment.user && comment.user.headimg_url ? comment.user.headimg_url : img.avatar" />
          </van-col>
          <van-col span="21">
            <h3>
              {{ comment.user.user_name }}
              <span class="binbox">
                <img class="binpic" @click="setCommentPraise(index)" :src="comment.is_praise ? img.parise_have : img.parise">
                <span class="sourtime">{{ comment.praise_num }}</span>
              </span>
            </h3>
            <p v-if="comment.content"><span v-if="comment.reuser">回复<i class="c-blue">@{{ comment.reuser.user_name }}：</i></span>{{ comment.content }}</p>
            <img v-for="(itemd, index) in comment.image" :key="'comment_img_' + index" v-lazy="itemd" />
            <van-row class="ct">
              <van-col span="14">
                <span class="f-12 c-gray">{{ comment.create_time }}
                  <span class="c-black" @click="replys(comment.id)"> · 回复
                    <span v-if="comment.replys">({{ comment.replys.length }})</span>
                  </span>
                </span>
              </van-col>
              <van-col span="10" class="tip">
                <span v-if="comment.user.id==params.user_id" class="f-12" @click="delComment(comment.id,index)">删除</span>
                <span v-else class="f-12" @click="toTip">举报</span>
              </van-col>
            </van-row>
          </van-col>
        </van-row>
      </div>
    </div>
  </van-list>
    <!-- <div class="text-c pd-30" @click="showQrcode" v-if="source==1&&comments.length>4">
      <div class="more_comm" :style="'background-image:url('+img.more_comm+')'">
        查看更多请访问小程序
      </div> 
    </div> -->
  </div>
  <div @touchstart="touchstart()" class="postoverlay" v-show="overlay"></div>
  <div class="postbottom" id="inputid" v-if="nobrowser">
    <van-row>
      <van-col :span="inputnum">
        <van-field v-model="value" @click="inputFocus()" :focus="inputfocus" placeholder="发表评论..." ref="inputTag" />
      </van-col>
      <van-col  v-if="inputshow" class="botright" span="10">
        <van-row>
          <van-col span="8"> 
            <span class="binbox">
              <img class="binpic" :src="img.comment">
              <span class="num" v-if="info.comment_num>0">{{info.comment_num}}</span>
            </span>
          </van-col>
          <van-col span="10">
            <span class="binbox" @click="Collect(info.is_collect)">
              <img class="binpic" :src="info.is_collect==1?img.collect_have:img.collect">
              <span class="num" v-if="info.collect_num>0">{{info.collect_num}}</span>
            </span>
          </van-col>
          <van-col span="6">
            <span class="binbox" @click="outrelay(info.title,info.content,'/lexus/article/'+info.id+'/post',info.image)">
              <img class="binpic" :src="img.outrelay">
            </span>
          </van-col>
        </van-row>
      </van-col>
      <van-col v-else span="5">
        <van-button color="#F6AB00" size="small" @click="post()">发表</van-button>
      </van-col>
    </van-row>
  </div>
  <van-action-sheet v-model="shareshow" :round="false" cancel-text="取消" @cancel="onCancel">
    <van-divider class="divider">分享</van-divider>
    <van-grid :border='false' :column-num="2">
      <van-grid-item :icon="img.friends" @click="toShare(2)" />
      <van-grid-item :icon="img.wechat" @click="toShare(1)" />
    </van-grid>
  </van-action-sheet>
  <div class="wask_page" v-if="qrcode" @click="hideQrcode"></div>
  <div class="wask_qrcode" :style="'background-image:url('+img.qrcode_bg+')'" v-if="qrcode">
    <img class="wechatqr" :src="img.wechateq">
    <div class="nocopy" style="margin-top: 30px;">微信扫码</div>
    <div class="nocopy">关注“{{wechat_name}}”小程序</div>
  </div>
</div>
</template>

<script>
  import bbs from '../../../api/bbs';
  import member from '../../../api/member/memberinfo';
  import { mapState } from 'vuex';
  import {Row, Col, Tab, Tabs,Tag,NavBar,Grid, GridItem,List,Field,Button,Overlay,ActionSheet,Divider,Icon } from "vant";
  export default {
    data () {
      return {
        params: {
          page: 1,
          size: 10,
          user_id: 0
        },
        bbs_id: 0,
        loading: false,
        finished: false,
        info: null,
        comments: [],
        value:'',
        inputshow:true,
        overlay:false,
        inputfocus:false,
        inputnum:14,
        rid:'',
        shareshow:false,
        nobrowser:false,
        qrcode:false,
        wechat_name:'汽车时间Motortime',
        pageLength:1,
        img: {
          avatar: require('../../../assets/img/default.jpg'),
          show_parise: require('../../../assets/img/show_parise.png'),
          parise: require('../../../assets/img/parise.png'),
          parise_have: require('../../../assets/img/parise_have.png'),
          loading: require('../../../assets/img/loading.gif'),
          collect: require('../../../assets/img/collect.png'),
          collect_have: require('../../../assets/img/collect_have.png'),
          comment: require('../../../assets/img/lexus/comment.png'),
          outrelay: require('../../../assets/img/lexus/outrelay.png'),
          friends: require('../../../assets/img/friend.png'),
          wechat: require('../../../assets/img/wecheck.png'),
          wechateq: require('../../../assets/img/wechateq.png'),
          more_comm: require('../../../assets/img/more_comm.png'),
          qrcode_bg: require('../../../assets/img/qrcode_bg.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
     this.pageLength=window.history.length
     this.weburl=process.env.VUE_APP_URL
     if(this.source == 3||this.source == 7) {
      this.$appService.isShowReturn({state: true})

    }
    this.$store.commit('param/show', false)
    let id = this.$route.params.id
    if(this.$util.isEmpty(id)) {
      this.$toast('帖子不存在')
      return false
    }
    if(localStorage.getItem('browser')){
      this.nobrowser=false
    }else{
      this.nobrowser=true
    }
    this.bbs_id = id

    this.getInfo()
    var apppar={
      title:this.$route.meta.title
    }
    this.$appService.changeTitle(apppar)
  },
  methods: {
    setPraise () {
      if(this.source == 3||this.source == 7) {
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
      }else if(this.source == 1){
        if(localStorage.getItem('token')){
          this.token=true
        }else{
          this.getAuthorization.getAuthorization();
        }
      }
      if(this.user) {
        let type = this.info.is_praise ? 2 : 1;
        bbs.setPraise({id: this.info.id, type: type}).then(res => {
          if(res.data.state == 1) {
            if(type == 1) {
              this.info.is_praise = 1
                // this.$toast.success('点赞成功')
              } else {
                this.info.is_praise = 0
                // this.$toast.success('取消成功')
              }
            }
          })
      } else {
        this.$toast('请先登录')
        return false
      }
    },
    setCommentPraise (index) {
      if(this.source == 3||this.source == 7) {
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
           var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      }else if(this.source == 1){
        if(localStorage.getItem('token')){
          this.token=true
        }else{
          this.getAuthorization.getAuthorization();
        }
      }
      if(this.user) {
        let type = this.comments[index].is_praise ? 2 : 1;
        bbs.setCommentPraise({id: this.comments[index].id, type: type}).then(res => {
          if(res.data.state == 1) {
            if(type == 1) {
              this.comments[index].is_praise = 1
              this.comments[index].praise_num += 1
              this.$toast.success('点赞成功')
            } else {
              this.comments[index].is_praise = 0
              this.comments[index].praise_num -= 1
              this.$toast.success('取消成功')
            }
          }
        })
      } else {
        this.$toast('请先登录')
        return false
      }
    },
    toTip() {
      this.$toast.success('举报成功')
    },
    getInfo () {
      let user_id = this.user ? this.user.id : 0
      bbs.getShow(this.bbs_id, {user_id: user_id}).then(res => {
        if(res.data.state == 1) {
          this.info = res.data.data
          if(res.data.data.title){
            document.title = res.data.data.title;
            var apppar={
              title:res.data.data.title
            }
            this.$appService.changeTitle(apppar)
            document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.data.title)
            document.querySelector('meta[name="description"]').setAttribute('content', res.data.data.title)
          }
          if(res.data.data.qrcode){
           this.img.wechateq=res.data.data.qrcode.image
           this.wechat_name=res.data.data.qrcode.name
         }

       }
     })
    },
    onClickLeft(){
      if(this.pageLength==1){
        this.$router.push({name:'Home'});
      }else{
        this.$router.go(-1)
      }
    },
  //==================================
  inputFocus(){//点击输入框聚焦

    if(this.source == 3||this.source == 7) {
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
         var params={
          url:'',
          pagetype:0
        }
        this.$appService.needLogin(params)
      }
    })
    }else if(this.source == 1){
      if(localStorage.getItem('token')){
        this.token=true
        member.getMemberInfo({source:this.source}).then(res => {
          if(res.data.state == 1) {
           var binding_status=res.data.data.phone_binding_status.status
           var mobile=res.data.data.mobile
           if(mobile){
            this.inputshow=false;
            this.overlay=true;
            this.inputnum=19;
            setTimeout(() => {
              var cc=document.getElementById('inputid');
              cc.scrollIntoViewIfNeeded(true);
            },500);
          }else{
            this.$refs.inputTag.blur()
            this.$dialog.confirm({
              title:'温馨提示',
              message: '根据国家《中华人民共和国网络安全法》规定，使用互联网服务需进行账号身份信息认证，还请您完成手机号码验证。验证后才能继续使用发布、评论等相关功能。感谢您的理解和支持！',
              width:'80%',
              messageAlign:'left',
              confirmButtonText:'去绑定',
            }).then(() => {

              this.$router.push({name:'BoundMobile',params:{source:this.source}});
            }).catch(() => {
              this.inputshow=false;
              this.overlay=true;
              this.inputnum=19;
              setTimeout(() => {
                var cc=document.getElementById('inputid');
                cc.scrollIntoViewIfNeeded(true);
              },500);
            });

          }

        }
      })
      }else{
        this.getAuthorization.getAuthorization();
      }
    }
    
  },
      replys(rid){//点击回复聚焦
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
             var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        }else if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
            member.getMemberInfo({source:this.source}).then(res => {
              if(res.data.state == 1) {
                var binding_status=res.data.data.phone_binding_status.status
                var mobile=res.data.data.mobile
                if(mobile){
                  this.inputshow=false;
                  this.overlay=true;
                  this.inputnum=19;
                  setTimeout(() => {
                    var cc=document.getElementById('inputid');
                    cc.scrollIntoViewIfNeeded(true);
                  },500);
                }else{
                  this.$refs.inputTag.blur()
                  this.$dialog.confirm({
                    title:'温馨提示',
                    message: '根据国家《中华人民共和国网络安全法》规定，使用互联网服务需进行账号身份信息认证，还请您完成手机号码验证。验证后才能继续使用发布、评论等相关功能。感谢您的理解和支持！',
                    width:'80%',
                    messageAlign:'left',
                    confirmButtonText:'去绑定',
                  }).then(() => {

                    this.$router.push({name:'BoundMobile',params:{source:this.source}});
                  }).catch(() => {
                    this.inputshow=false;
                    this.overlay=true;
                    this.inputnum=19;
                    setTimeout(() => {
                      var cc=document.getElementById('inputid');
                      cc.scrollIntoViewIfNeeded(true);
                    },500);
                  });
                  
                }

              }
            })
          }else{
            this.getAuthorization.getAuthorization();
          }
        }
        this.inputshow=false;
        this.overlay=true;
        this.inputnum=19;
        this.inputfocus=true
        this.$refs.inputTag.focus()
        this.rid=rid
        setTimeout(() => {
          var cc=document.getElementById('inputid');
          cc.scrollIntoViewIfNeeded(true);
        },500);
      },
      touchstart(){//检测触发遮罩层，失去焦点
        this.inputshow=true;
        this.overlay=false;
        this.$refs.inputTag.blur()
        this.inputnum=14;
        this.inputfocus=false
      },
      inputBlur(){//点击失去焦点
        setTimeout(() => {
          this.inputshow=true;
          this.inputnum=14;
        }, 1000);
        this.overlay=false;
        this.inputfocus=false
        this.$refs.inputTag.blur()
      },
      post(){
        let params={
          rid:this.rid,
          card_id:this.bbs_id,
          content:this.value
        }
        bbs.Comment(params).then(res => {
         if(res.data.state == 1) {
          this.inputshow=true;
          this.inputnum=14;
          this.overlay=false;
          this.inputfocus=false
          this.$refs.inputTag.blur()
          this.$toast.success('发表成功')
          this.value=''
          this.finished = false
          this.comments=[]
          this.params.page = 1
        }
      })
      },
      Collect(type){
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
             var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        }else if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
          }else{
            this.getAuthorization.getAuthorization();
          }
        }
        var param={
          id:this.info.id,
          type: type==1?2:1
        }
        bbs.Collect(param).then(res => {
          if(res.data.state == 1) {
            if(param.type == 1) {
              this.info.is_collect = 1
              this.info.collect_num += 1
            } else {
              this.info.is_collect = 0
              this.info.collect_num -= 1
            }
          }
        })
      },
      delComment(id,index){
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
             var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        }else if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
          }else{
            this.getAuthorization.getAuthorization();
          }
        }
        this.$dialog.confirm({
          message: '确定要删除吗？'
        }).then(() => {
         bbs.delComment(id).then(res => {
          if(res.data.state == 1) {
            this.$toast.success('已删除')
            this.comments.splice(index,1);
          }
        })
       }).catch(() => {});
      },
      onCancel(){
        this.actionshow=false
      },
      outrelay(title,content,url,imageUrl){
        if(this.source==3){
          this.shareshow=true
          this.sharetitle=title
          this.sharecontent=content
          this.shareurl=this.weburl+url
          if(imageUrl){
            this.shareimageUrl=imageUrl
          }else{
            this.shareimageUrl='https://pic.motortime.com/logo/motortime_logo.png'
          }
        }else{
          this.$toast.success('请点击右上角选项分享')
        }
      },
      toShare(type){
        var params={
          type:type,
          title:this.sharetitle,
          content:this.sharecontent,
          url:this.shareurl,
          imageUrl:this.shareimageUrl
        }
        this.shareshow=false
        this.$appService.shareContent(params)
      },
      showQrcode(){
        this.qrcode=true
      },
      hideQrcode(){
       this.qrcode=false
     },
     onLoad() {
      this.params.user_id = this.user ? this.user.id : 0
      // 异步更新数据
      setTimeout(() => {
        this.params.source=this.source
        bbs.getCommentList(this.bbs_id, this.params).then(res => {
          this.comments.push.apply(this.comments, res.data.data.data)
          this.params.page += 1
          if(this.source!=1){
            this.loading = false
            if(res.data.data.data.length == 0) {
              this.finished = true
            }
          }
        })
      }, 500);
    }
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [NavBar.name]:NavBar,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [List.name]:List,
    [Field.name]:Field,
    [Button.name]:Button,
    [Overlay.name]:Overlay,
    [ActionSheet.name]:ActionSheet,
    [Divider.name]:Divider,
    [Icon.name]:Icon,
  }
};
</script>

<style lang="scss">
  .bbs-show {
    background-color: #F0F0F0;
  // .van-nav-bar__left {
  //  left: 10px;
  // }
  .show {
    padding: 10px;
    overflow: hidden;
    background-color: #FFF;

    .listhand{
      width:45px;
      height:45px;
      border-radius:30px;
    }
    .membername{
      font-size: 15px;
      font-weight: bold;
    }
    .sourtime{
      font-size: 12px;
      color: #9A9A9A;
    }
    .bintright {
      text-align:right;

      .van-button--default {
        color: #F6AB00;
        border: 1px solid #F6AB00;
        width: 60px;
        height: 25px;
        line-height: 25px;
        font-size: 12px;
        padding: 0;
      }
    }
    h1 {
      font-size: 16px;
    }
    p {
      margin: 0;
      font-size: 14px;
    }
    .img {
      width: 100%;
      margin-top: 10px;
      border-radius: 5px;
      display: block;
    }
    .van-tag {
      color: #3A3A3A;
    }
    .tip {
      text-align: right;

      span {
        color: #9A9A9A;
        font-size: 12px;
      }
    }
    .parise {
      text-align: center;
      margin-top: 10px;

      a {
        color: #3A3A3A;
        font-size: 11px;
        display: inline-block;
        width: 110px;
        height: 35px;
        border: 1px solid #9A9A9A;
        line-height: 35px;
        border-radius: 17px;
        margin: 0 7px;

        img {
          width: 15px;
          height: 14px;
          vertical-align: middle;
          margin: 0;
          margin-right: 7px;
        }
      }
    }
  }
  .comments {
    background-color: #FFF;
    margin-top: 10px;

    h2 {
      font-size: 13px;
      font-weight: normal;
      padding: 15px 10px;
      border-bottom: 1px solid #EAEAEA;
      margin: 0;
    }
    .comment {
      margin: 0 10px;
      overflow: hidden;

      .van-row {
        border-bottom: 1px solid #EAEAEA;
        padding: 10px 0;

        &.ct {
          border: none;
          padding: 0;

          .tip {
            text-align: right;
          }
        }
      }
      .avatar {
        width: 30px;
        height: 30px;
        object-fit: cover;
        border-radius: 15px;
      }
      h3 {
        font-size: 15px;
        margin: 0;

        .binbox {
          color: #9A9A9A;
          font-size: 12px;
          float: right;
          font-weight: normal;

          img {
            width: 15px;
            height: 14px;
            margin-right: 11px;
          }
        }
      }
      p {
        font-size: 15px;
        margin: 5px 0;

        .c-blue {
          font-style: normal;
        }
      }
      img {
        width: 280px;
        border-radius: 5px;
      }
      .ctime {

      }
    }

  }
}
</style>
